const responsiveStringRegex = /([a-zA-Z0-9-]+)@([a-zA-Z0-9-]+)/;
const isResponsiveProperty = (value) => {
    return !!value && typeof value === 'string' ? responsiveStringRegex.test(value) : false;
};
const parseResponsiveProperty = (responsiveProperty) => {
    const properties = responsiveProperty.match(new RegExp(responsiveStringRegex, 'g'));
    return Object.fromEntries(properties.map((property) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [match, value, breakpoint] = property.match(responsiveStringRegex);
        return [breakpoint, value];
    }));
};
const serializeResponsiveProperty = (responsiveProperty) => {
    return Object.entries(responsiveProperty)
        .map(([breakpoint, value]) => `${value}@${breakpoint}`)
        .join(' ');
};
const mapResponsiveProperty = (input, dictionary) => {
    const mappedPropertyArray = Object.entries(input).map(([breakpoint, value]) => {
        return [breakpoint, dictionary[value]];
    });
    return Object.fromEntries(mappedPropertyArray);
};

export { isResponsiveProperty as i, mapResponsiveProperty as m, parseResponsiveProperty as p, serializeResponsiveProperty as s };
